import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const SpaceStorySection = styled.section`
  //max-width: 1920px;
  margin: 0 auto;

  svg {
    width: 100%;
    height: auto;
    position: relative;
  }

  .mobile {
    ${breakpoints.MD} {
      display: none;
    }
  }

  .desktop {
    display: none;

    ${breakpoints.MD} {
      display: block;
    }
  }
`;

const Episode = styled.div`
  position: relative;
  overflow: hidden;
  width: calc(100% + 2px);
  left: -1px;

  .graphics {
    position: absolute;
  }
`;

const Text = styled.div`
  color: ${({ theme }) => theme.colors.text.white};
  background-color: #000;
  padding: 10px 11px;
  border: 2px solid ${({ theme }) => theme.colors.text.white};
  position: absolute;
  font-family: 'PPFormula', sans-serif;
  font-size: 15px;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.01em;
`;

const Episode1 = styled(Episode)`
  border-radius: ${({ theme }) => theme.spacings.x6}
    ${({ theme }) => theme.spacings.x6} 0 0;
  height: 240px;

  ${Text} {
    border-top-left-radius: ${({ theme }) => theme.spacings.x6};
    top: -2px;
    left: -1px;
    width: 203px;
    text-align: right;
    z-index: 5;
  }

  .planet {
    z-index: 1;
  }

  .space {
    z-index: 2;
  }

  .ship {
    z-index: 3;
  }

  //clip-path: path(
  //  'M189.11 216.845L373.895 242.257L373.895 0L0.000671387 -1.63434e-05L0.000662071 213.118L217.811 242.257L189.11 216.845Z'
  //);

  .border {
    position: absolute;
    top: -1px;
    width: calc(100% + 15px);
    left: -5px;
    height: 100%;
  }
`;

const Episode2 = styled(Episode)`
  height: 240px;

  ${Text} {
    bottom: 0;
    right: 0;
  }
`;

const Episode3 = styled(Episode)`
  border-radius: 0 0 ${({ theme }) => theme.spacings.x6}
    ${({ theme }) => theme.spacings.x6};
  height: 240px;
`;

export { SpaceStorySection, Episode1, Episode2, Episode3, Text };
